import { useMemo } from 'react'

import { FeedsMarketQuery, FeedsMarketQueryVariables } from '../../api/gqlaxy/gql/generated/graphql'
import { ErrorPrompt, OptionQuery } from '../../types/error'
import { QueryKey } from '../../constants/queryKey'
import { graphqlGLClient } from '../../api/gqlaxy/gql/queries/graphQLClient'
import { useFeedsMarketQuery } from '../../api/gqlaxy/gql/generated/graphql-hooks'
import { useGQLErrorHandler } from '..'

// errorPrompts are coming for the parent component
// If we have some prompts that should be used with any parent, we can add them here
const localErrorPrompts: ErrorPrompt[] = [
  {
    error: 'feedsMarket-postalCodeRequired',
    disableErrorPrompts: true
  }
]

export const useGetFeedsMarket = (param: FeedsMarketQueryVariables, option: OptionQuery<FeedsMarketQuery>) => {
  const client = graphqlGLClient({
    // endpoint: 'http://127.0.0.1:5001/mobile-staging-376418/us-central1/gqlactus' // local endpoint
  })

  const { disableErrorPrompts, errorPrompts = [], ...options } = option

  const combinedErrorPrompts = useMemo(() => [...localErrorPrompts, ...errorPrompts], [errorPrompts])

  const handleError = useGQLErrorHandler({ disableErrorPrompts, errorPrompts: combinedErrorPrompts })

  return useFeedsMarketQuery(client, param, {
    queryKey: [QueryKey.GetFeedsMarket, param.input],
    onError: handleError,
    ...options
  })
}
